<template>
  <div class="login-container">
    <div class="background-image"></div>
    <div class="login-form">
      <div class="logo-header">
        <el-image
          class="logo-img"
          :src="require('@/assets/logo_new.png')"
          fit="contain"
        ></el-image>
      </div>
      <div class="brand-copy">
        <div class="brand-slogan">{{ $t('register.brandSlogan') }}</div>
        <div class="brand-desc">{{ $t('register.brandDesc') }}</div>
        <div class="brand-meta">
          <span>{{ $t('register.assistant247') }}</span>
          <span>{{ $t('register.poweredByEva') }}</span>
        </div>
      </div>
      <div class="form-panel">
        <div class="form-title">{{ $t('register.registerAccount') }}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item :label="$t('register.account')" prop="username">
            <el-input v-model="ruleForm.username" prefix-icon="el-icon-user" clearable :placeholder="$t('register.placeholder.inputEmail')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('register.verificationCode')" prop="captcha">
            <el-input v-model="ruleForm.captcha" prefix-icon="el-icon-message" clearable :placeholder="$t('register.placeholder.inputCode')">
              <template slot="append">
                <span class="code-btn" v-if="codeCd">{{ $t('register.getCodeCountdown', [long]) }}</span>
                <span class="code-btn" v-else @click="sendCode">{{ $t('register.getCode') }}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('register.phoneNumber')" prop="mobile">
            <el-input v-model="ruleForm.mobile" prefix-icon="el-icon-phone-outline" clearable :placeholder="$t('register.placeholder.inputPhone')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('register.password')" prop="password">
            <el-input v-model="ruleForm.password" type='password' prefix-icon="el-icon-lock" show-password autocomplete="off" :placeholder="$t('register.placeholder.inputPassword')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('register.confirmPassword')" prop="password1">
            <el-input v-model="ruleForm.password1" type='password' prefix-icon="el-icon-lock" show-password autocomplete="off" :placeholder="$t('register.placeholder.inputConfirmPassword')"></el-input>
          </el-form-item>
          <div class="no-pass">
            <span class="no-pass-btn" @click="goLogin">{{ $t('register.login') }}</span>
          </div>
          <div class="legal-consent">
            <el-checkbox v-model="legalAgreed"></el-checkbox>
            <div class="legal-consent-text">
              <span>{{ $t('register.consentPrefix') }}</span>
              <a href="https://www.ecpai.com/terms.html" target="_blank" rel="noopener noreferrer">{{ $t('register.terms') }}</a>
              <span>{{ $t('register.consentMiddle') }}</span>
              <a href="https://www.ecpai.com/privacy.html" target="_blank" rel="noopener noreferrer">{{ $t('register.privacy') }}</a><span>{{ $t('register.consentSuffix') }}</span>
            </div>
          </div>
          <el-form-item>
            <el-button type="primary" :disabled="!legalAgreed" @click="submitForm('ruleForm')" style="width: 100%">{{ $t('register.register') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="legal-footer">
        <div>{{ $t('register.legalCopyright') }}</div>
        <div class="legal-footer-links">
          <a href="https://www.ecpai.com/terms.html" target="_blank" rel="noopener noreferrer">{{ $t('register.terms') }}</a>
          <span>|</span>
          <a href="https://www.ecpai.com/privacy.html" target="_blank" rel="noopener noreferrer">{{ $t('register.privacy') }}</a>
          <span>|</span>
          <a href="https://www.ecpai.com/prohibited.html" target="_blank" rel="noopener noreferrer">{{ $t('register.prohibited') }}</a>
        </div>
      </div>
    </div>
    <!-- <div class="x-tips">CTS GLOBAL SUPPLY CHAIN SOLUTIONS</div> -->
  </div>
</template>

<script>
import { usersRegister, sendEmailCode } from '@/api/login'
// import { usersRegister } from '@/api/ltl/login'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register.requiredMessage.newPassword')));
      } else {
        if (this.ruleForm.password1 !== '') {
          this.$refs.ruleForm.validateField('password1');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register.requiredMessage.reEnterPassword')));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$t('register.requiredMessage.passwordNotMatch')));
      } else {
        callback();
      }
    };

    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('register.requiredMessage.phone')));
      } else {
        callback();
      }
      // else if (!/^1[3456789]\d{9}$/.test(value)) {
      //   callback(new Error(this.$t('register.formatMessage.phone')));
      // } 

    };
    return {
      formVisible: false,
      code: '',
      long: 60,
      codeCd: false,
      codeTimer: null,
      legalAgreed: false,
      ruleForm: {
        username: "",
        mobile: "",
        password: "",
        password1: '',
        captcha: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('register.requiredMessage.account'), trigger: 'blur' },
          { type: 'email', message: this.$t('register.formatMessage.email'), trigger: ['blur', 'change'] }
        ],
        captcha: [
          { required: true, message: this.$t('register.requiredMessage.code'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        password1: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    // 从 URL 中获取代理商推广码
    const url = window.location.href
    const match = url.match(/[?&]code=([^&]*)/)
    if (match) {
      try {
        this.code = decodeURIComponent(match[1].replace(/\+/g, '%2B'))
      } catch (e) {
        this.code = match[1]
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清除验证码倒计时，防止 timer 泄漏
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
    }
  },
  methods: {
    // 发送邮箱验证码
    sendCode() {
      this.$refs.ruleForm.validateField('username', (errMsg) => {
        if (errMsg) return;
        sendEmailCode({ email: this.ruleForm.username, event: 'register', lang: window.localStorage.getItem('lhkdLang') || 'en' }).then(res => {
          if (res.code == 1) {
            this.$message.success(res.msg);
            this.codeCd = true;
            // 清除可能存在的旧计时器，避免重复
            if (this.codeTimer) clearInterval(this.codeTimer);
            this.codeTimer = setInterval(() => {
              this.long--;
              if (this.long <= 0) {
                this.long = 60;
                this.codeCd = false;
                clearInterval(this.codeTimer);
                this.codeTimer = null;
              }
            }, 1000);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    goLogin(){
      this.$router.push({ path: '/login'})
    },
    // 关闭
    closeDialog(){
      this.formVisible = false
    },
    // 登录/注册
    submitForm(formName) {
      if (!this.legalAgreed) {
        this.$message.warning(this.$t('register.consentRequired'));
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            ...this.ruleForm,
            code: this.code,
            legal_accepted: 1,
            terms_version: '2026080304',
            privacy_version: '2026080304',
            consent_text: this.$t('register.consentText'),
            consent_locale: this.$i18n.locale === 'en' ? 'en' : 'zh'
          }
          usersRegister(params).then(res => {
            if(res.code == 1){
              // window.localStorage.setItem("userInfo1",JSON.stringify(res.data.userinfo))
              // window.localStorage.setItem("userInfo1",JSON.stringify(res.data))  // ltl
              this.$message.success(res.msg)
              this.$router.push({ path: '/login'});
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 24px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #0a1f4d;
  background-image: url("~@/assets/bg_wide.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-form {
  width: 460px;
  margin: auto 0;
  z-index: 99;
  box-sizing: border-box;
  padding: 14px 30px 22px;
  // 蓝色玻璃拟态主体背景
  background: rgba(90, 150, 230, 0.30);
  // 背景模糊
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border-radius: 24px;
  // 很淡的白色描边
  border: 1px solid rgba(255, 255, 255, 0.5);
  // 蓝色发光阴影
  box-shadow: 0 0 50px rgba(120, 180, 255, 0.55), inset 0 0 36px rgba(255, 255, 255, 0.14);
  position: relative;

  // logo 顶部区域
  .logo-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0 12px;
    .logo-img {
      width: 340px;
      height: 102px;
      // 将深色 logo 转为纯白，匹配参考图
      /deep/ img {
        filter: brightness(0) invert(1);
      }
    }
  }

  // 输入区面板：稍亮的内层玻璃
  .brand-copy {
    margin: -8px 0 12px;
    color: #ffffff;
    text-align: center;
  }

  .brand-slogan {
    font-size: 15px;
    font-weight: 600;
  }

  .brand-desc {
    margin-top: 3px;
    color: rgba(255, 255, 255, 0.86);
    font-size: 12px;
  }

  .brand-meta {
    display: flex;
    justify-content: center;
    gap: 14px;
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 11px;
  }

  .form-panel {
    background: rgba(255, 255, 255, 0.22);
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    padding: 16px 20px 4px;
  }

  .form-title {
    margin-bottom: 12px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }

  .demo-ruleForm {
    width: 100%;
  }
}

// 表单标签：白色，置于输入框上方，靠左对齐
/deep/.el-form-item__label {
  color: #ffffff !important;
  font-weight: 500;
  font-size: 15px;
  padding-bottom: 4px !important;
  line-height: 1.4;
  text-align: left !important;
  width: 100% !important;
  float: none !important;
  display: block;
}
/deep/.el-form-item {
  margin-bottom: 22px;
}
// 隐藏必填项红色星号
/deep/.el-form-item.is-required .el-form-item__label:before {
  display: none !important;
}
// 校验错误提示：醒目颜色，避免被下一项遮挡
/deep/.el-form-item__error {
  color: #ffd54a;
  font-size: 13px;
  padding-top: 2px;
}

// 输入框：浅白色高不透明，圆角，清晰可见
/deep/.el-input__inner {
  height: 42px;
  line-height: 42px;
  background: rgba(255, 255, 255, 0.9) !important;
  border: none !important;
  border-radius: 12px !important;
  padding-left: 44px !important;
  // 文字深蓝灰色
  color: #2c3e54 !important;
  font-size: 15px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
/deep/.el-input__inner::placeholder {
  color: #8a99ab !important;
}
// 输入框内前缀图标
/deep/.el-input__prefix {
  left: 12px;
  display: flex;
  align-items: center;
}
/deep/.el-input--prefix .el-input__prefix .el-input__icon,
/deep/.el-input__prefix .el-input__icon {
  font-size: 20px;
  color: #1a2a5e !important;
  line-height: 42px;
}
/deep/.el-input__icon {
  font-size: 18px;
  color: #1a2a5e !important;
  line-height: 42px;
}
// 密码显隐眼睛图标放大
/deep/.el-input__suffix {
  right: 12px;
}
/deep/.el-input__suffix .el-input__icon {
  font-size: 22px;
  color: #1a2a5e !important;
}

// 注册按钮：深亮蓝色，强化视觉焦点
/deep/.el-button--primary {
  height: 46px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 1px;
  background-color: #0a52d8 !important;
  border-color: #0a52d8 !important;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(10, 82, 216, 0.5);
}
/deep/.el-button--primary:hover {
  background-color: #0843b5 !important;
  border-color: #0843b5 !important;
}

.no-pass {
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
  margin-top: -2px;
  .no-pass-btn {
    line-height: 24px;
    font-size: 15px;
    cursor: pointer;
    color: #bfe0ff;
    text-decoration: underline;
  }
}
.legal-consent {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  text-align: left;
  line-height: 1.5;

  /deep/ .el-checkbox__input {
    margin-top: 3px;
  }

  .legal-consent-text {
    margin-left: 8px;
    color: #ffffff;
  }

  a {
    color: #bfe0ff;
    text-decoration: underline;
  }
}
.legal-footer {
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}
.legal-footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;

  a {
    color: #bfe0ff;
    text-decoration: underline;
  }
}
// 验证码栏：输入框左侧保持圆角，右侧拼接蓝色"获取验证码"按钮，与注册按钮风格统一
/deep/.el-input-group--append .el-input__inner {
  border-radius: 12px 0 0 12px !important;
}
/deep/.el-input-group__append {
  background-color: #0a52d8 !important;
  border: none !important;
  border-radius: 0 12px 12px 0 !important;
  padding: 0 16px !important;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
/deep/.el-input-group__append:hover {
  background-color: #0843b5 !important;
}
.code-btn {
  cursor: pointer;
  color: #ffffff;
  user-select: none;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}

// 低高度屏幕压缩垂直间距，确保注册卡片完整显示且页面不滚动
@media (max-height: 900px) {
  .login-container {
    padding: 12px 0;
  }

  .login-form {
    padding: 8px 24px 12px;
    border-radius: 20px;

    .logo-header {
      padding: 0 0 4px;

      .logo-img {
        width: 250px;
        height: 70px;
      }
    }

    .brand-copy {
      margin: -4px 0 6px;
    }

    .brand-desc {
      margin-top: 1px;
    }

    .brand-meta {
      margin-top: 2px;
    }

    .form-panel {
      padding: 10px 16px 0;
      border-radius: 16px;
    }

    .form-title {
      margin-bottom: 6px;
      font-size: 17px;
    }
  }

  /deep/.el-form-item {
    margin-bottom: 12px;
  }

  /deep/.el-form-item__label {
    padding-bottom: 2px !important;
    font-size: 14px;
    line-height: 1.25;
  }

  /deep/.el-input__inner {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }

  /deep/.el-input--prefix .el-input__prefix .el-input__icon,
  /deep/.el-input__prefix .el-input__icon,
  /deep/.el-input__icon {
    line-height: 36px;
  }

  /deep/.el-button--primary {
    height: 38px;
    font-size: 15px;
  }

  .no-pass {
    margin-top: -2px;
    margin-bottom: 4px;

    .no-pass-btn {
      line-height: 20px;
      font-size: 14px;
    }
  }

  .legal-consent {
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.4;
  }

  .legal-footer {
    margin-top: 7px;
    font-size: 11px;
    line-height: 1.4;
  }
}

@media (max-height: 760px) {
  .login-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.94);
    transform-origin: center;
  }
}

@media (max-height: 680px) {
  .login-form {
    transform: translate(-50%, -50%) scale(0.8);
  }
}
</style>
